<template>
  <div class="bg-gradient-to-b from-gray-900 to-blue-900 min-h-screen w-full">
    <div class="px-4 py-8 mx-auto container max-w-4xl">
      <!-- Naslov stranice -->
      <h1
        class="text-3xl font-bold text-white mb-6 border-b border-blue-500 pb-2 inline-block"
      >
        Kako obrisati nalog
      </h1>

      <!-- Main content -->
      <div
        class="bg-gray-800 rounded-lg shadow-xl overflow-hidden border border-blue-500"
      >
        <!-- Header -->
        <div class="bg-gradient-to-r from-blue-800 to-blue-600 p-6">
          <div class="flex items-center space-x-4">
            <!-- Info Icon -->
            <div
              class="bg-blue-700 rounded-full h-20 w-20 sm:h-24 sm:w-24 flex items-center justify-center text-2xl sm:text-3xl text-white font-bold shadow-lg border-2 border-blue-300 flex-shrink-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-12 w-12 sm:h-16 sm:w-16"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <!-- Title -->
            <div class="ml-2 min-w-0 flex-1">
              <h2 class="text-2xl sm:text-3xl font-bold text-white break-words">
                Uputstvo za brisanje
              </h2>
              <p class="text-blue-200 text-base sm:text-lg break-words">
                Korak po korak vodic
              </p>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div class="p-4 sm:p-8 bg-gradient-to-b from-gray-800 to-gray-900">
          <!-- Step by Step Instructions -->
          <div
            class="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg border border-blue-400 mb-6"
          >
            <h3
              class="text-lg sm:text-xl font-semibold text-white mb-6 border-b border-blue-400 pb-2 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2 text-blue-400 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                />
              </svg>
              <span class="break-words min-w-0">Koraci za brisanje naloga</span>
            </h3>

            <div class="space-y-6">
              <!-- Step 1 -->
              <div
                class="flex items-start space-x-4 p-4 bg-gray-700 rounded-lg border-l-4 border-blue-500"
              >
                <div
                  class="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0"
                >
                  1
                </div>
                <div class="flex-1">
                  <h4 class="text-white font-semibold mb-2">
                    Otvorite Side Menu (Bocni meni)
                  </h4>
                  <p class="text-gray-300 text-sm">
                    Kliknite na ikonicu za meni (☰) koja se nalazi u donjem
                    desnom uglu ekrana.
                  </p>
                  <div class="mt-3 p-3 bg-gray-600 rounded-md">
                    <p class="text-blue-200 text-xs">
                      💡 <strong>Savet:</strong> Side Menu mozete otvoriti i
                      prevlacenjem prsta sa leve strane ekrana ka desno.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Step 2 -->
              <div
                class="flex items-start space-x-4 p-4 bg-gray-700 rounded-lg border-l-4 border-blue-500"
              >
                <div
                  class="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0"
                >
                  2
                </div>
                <div class="flex-1">
                  <h4 class="text-white font-semibold mb-2">
                    Pronadjite "Moj Nalog"
                  </h4>
                  <p class="text-gray-300 text-sm">
                    U Side Menu-u, skrolujte i pronadjite opciju
                    <strong class="text-blue-300">"Moj Nalog"</strong>.
                  </p>
                  <div class="mt-3 p-3 bg-gray-600 rounded-md">
                    <p class="text-blue-200 text-xs">
                      📍 Ova opcija se obicno nalazi u donjem delu menija,
                      zajedno sa drugim nalogskim opcijama.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Step 3 -->
              <div
                class="flex items-start space-x-4 p-4 bg-gray-700 rounded-lg border-l-4 border-blue-500"
              >
                <div
                  class="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0"
                >
                  3
                </div>
                <div class="flex-1">
                  <h4 class="text-white font-semibold mb-2">
                    Kliknite na "Moj Nalog"
                  </h4>
                  <p class="text-gray-300 text-sm">
                    Dodirnite ili kliknite na
                    <strong class="text-blue-300">"Moj Nalog"</strong> da
                    otvorite podmeni sa opcijama naloga.
                  </p>
                </div>
              </div>

              <!-- Step 4 -->
              <div
                class="flex items-start space-x-4 p-4 bg-red-900 bg-opacity-30 rounded-lg border-l-4 border-red-500"
              >
                <div
                  class="bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0"
                >
                  4
                </div>
                <div class="flex-1">
                  <h4 class="text-white font-semibold mb-2">
                    Izaberite "Obrisi nalog"
                  </h4>
                  <p class="text-gray-300 text-sm">
                    U podmeniju "Moj Nalog", pronadjite i kliknite na
                    <strong class="text-red-300">"Obrisi nalog"</strong>.
                  </p>
                  <div
                    class="mt-3 p-3 bg-red-800 bg-opacity-40 rounded-md border border-red-600 border-opacity-50"
                  >
                    <p class="text-red-200 text-xs flex items-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 mr-2 mt-0.5 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                      <strong>Paznja:</strong> Ova opcija je obicno oznacena
                      crvenom bojom zbog vaznosti akcije.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Step 5 -->
              <div
                class="flex items-start space-x-4 p-4 bg-yellow-900 bg-opacity-30 rounded-lg border-l-4 border-yellow-500"
              >
                <div
                  class="bg-yellow-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0"
                >
                  5
                </div>
                <div class="flex-1">
                  <h4 class="text-white font-semibold mb-2">
                    Pratite uputstva za potvrdu
                  </h4>
                  <p class="text-gray-300 text-sm">
                    Aplikacija ce vas voditi kroz proces potvrde gde cete morati
                    da potvrdite svoju odluku.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- What will be deleted section -->
          <div
            class="bg-red-900 bg-opacity-20 p-4 sm:p-6 rounded-lg shadow-lg border border-red-500 border-opacity-50 mb-6"
          >
            <h3
              class="text-lg sm:text-xl font-semibold text-red-400 mb-4 border-b border-red-500 border-opacity-50 pb-2 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2 text-red-400 flex-shrink-0"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="break-words min-w-0">Sta ce biti obrisano</span>
            </h3>

            <div class="space-y-4">
              <p class="text-red-300 text-sm sm:text-base">
                Kada obrisete nalog, sledeci podaci ce biti
                <strong>trajno obrisani</strong>:
              </p>

              <div
                class="bg-red-800 bg-opacity-40 p-4 rounded-md border border-red-600 border-opacity-60"
              >
                <ul class="text-red-300 text-sm space-y-3 list-none">
                  <li class="flex items-start">
                    <span class="text-red-400 mr-3 text-lg">•</span>
                    <span
                      ><strong>Vas profil:</strong> ime, prezime, email,
                      korisnicko ime, grad</span
                    >
                  </li>
                  <li class="flex items-start">
                    <span class="text-red-400 mr-3 text-lg">•</span>
                    <span
                      ><strong>Svi oglasi:</strong> sve vase objavljene slike i
                      opisi</span
                    >
                  </li>
                  <li class="flex items-start">
                    <span class="text-red-400 mr-3 text-lg">•</span>
                    <span
                      ><strong>Komunikacija:</strong> istorija poruka sa drugim
                      korisnicima</span
                    >
                  </li>
                  <li class="flex items-start">
                    <span class="text-red-400 mr-3 text-lg">•</span>
                    <span
                      ><strong>Preferencije:</strong> sacuvane pretrage i
                      favoriti</span
                    >
                  </li>
                </ul>
              </div>

              <div
                class="bg-yellow-900 bg-opacity-30 p-4 rounded-md border border-yellow-600 border-opacity-50"
              >
                <p class="text-yellow-200 text-sm flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 mr-2 mt-0.5 flex-shrink-0 text-yellow-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                  <span>
                    <strong>Vazno:</strong> Ova akcija je neporatna! Kada
                    obrisete nalog, nema mogucnosti povracaja podataka.
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!-- Alternative options -->
          <div
            class="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg border border-gray-600"
          >
            <h3
              class="text-lg sm:text-xl font-semibold text-white mb-4 border-b border-gray-600 pb-2 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2 text-green-400 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                />
              </svg>
              <span class="break-words min-w-0">Kontakt podrska</span>
            </h3>

            <div class="space-y-4">
              <p class="text-gray-300 text-sm sm:text-base">
                Pre nego sto obrisete nalog, mozete kontaktirati nasu podresku
                za pomoc:
              </p>

              <div
                class="bg-blue-900 bg-opacity-20 p-4 rounded-md border border-blue-600 border-opacity-50"
              >
                <h4 class="text-blue-300 font-semibold mb-2 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z"
                    />
                  </svg>
                  Korisnička podrška
                </h4>
                <p class="text-blue-200 text-xs">
                  Kontaktirajte nas ako imate problem koji mozemo resiti
                </p>
              </div>
            </div>
          </div>

          <!-- Back button -->
          <div class="flex justify-center mt-6">
            <button
              @click="goBack"
              class="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors shadow-lg text-sm sm:text-base font-medium flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              Nazad
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'DeleteAccountManualView',
  setup() {
    const router = useRouter();

    // Go back to previous page
    const goBack = () => {
      router.go(-1);
    };

    return {
      goBack,
    };
  },
});
</script>
